import {Platform, StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  form: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '1rem',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 24,
  },
  inputGroup: {
    width: Platform.OS == 'web' ? '95%' : '90%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  inputRow: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
  },
  inputGroupElement: {
    // flexBasis: '45%',
    maxWidth: '45%',
  },
  addBtn: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    gap: 12,
    alignSelf: 'flex-end',
    marginVertical: 12,
    zIndex: -1,
  },
  addBtnText: {
    color: '#58A618',
    fontWeight: 700,
  },
  imgIcon: {width: 20, height: 20},
  inputText: {marginBottom: 0},
  removeBtn: {
    marginTop: 15,
  },
});
